import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a31d91c6-928d-4105-9cc7-4850ef18f1bb/artifacts/zj9kpzwc_JD%20Design%20Haus%20logo%20in%20grayscale%20%281%29.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-onyx text-bone">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Brand */}
          <div>
            <img
              src={LOGO_URL}
              alt="J Design Haus"
              className="h-16 w-auto mb-6"
              style={{ filter: "brightness(0) invert(1)" }}
            />
            <p className="text-sm font-light text-concrete leading-relaxed max-w-xs">
              Scottsdale-based interior design studio specializing in elevated,
              architectural spaces.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs tracking-[0.25em] uppercase text-taupe mb-6">
              Navigation
            </p>
            <div className="flex flex-col gap-3">
              {["About", "Services", "Portfolio", "Journal", "Contact"].map((item) => (
                <Link
                  key={item}
                  to={`/${item.toLowerCase()}`}
                  data-testid={`footer-${item.toLowerCase()}`}
                  className="text-sm font-light text-concrete hover:text-bone transition-colors duration-300"
                >
                  {item}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="text-xs tracking-[0.25em] uppercase text-taupe mb-6">
              Get in Touch
            </p>
            <div className="flex flex-col gap-3 text-sm font-light text-concrete">
              <a href="tel:480-527-8858" className="hover:text-bone transition-colors">
                480-527-8858
              </a>
              <a href="mailto:jamie@jdesignhaus.com" className="hover:text-bone transition-colors">
                jamie@jdesignhaus.com
              </a>
              <p>Scottsdale, Phoenix, Paradise Valley &amp; surrounding areas</p>
              <a
                href="https://www.instagram.com/jdesignhaus"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-bone transition-colors"
              >
                @jdesignhaus
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-bone/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-concrete/60 font-light">
            &copy; {new Date().getFullYear()} J Design Haus. All rights reserved.
          </p>
          <p className="text-xs text-concrete/60 font-light">
            Elevated Spaces. Crafted with Intention.
          </p>
        </div>
      </div>
    </footer>
  );
}
